/* matches: fwd, rev, primer, i0 i7*/
import type { HeaderMatcher } from './SelectorUtil.js'
import { partialMatcher, wordMatcher } from './SelectorUtil.js'
import type { CSVFieldType } from './CsvModalAISelector.js'

const ForwardPrimerMatcher = partialMatcher([['forward'], ['fwd'], ['i5']], ['primer'], 'Forward Primer Matcher')

const ReversePrimerMatcher = partialMatcher([['reverse'], ['rev'], ['i7']], ['primer'], 'Reverse Primer Matcher')

const SequenceMatcher = partialMatcher([['sequenc']], [], 'Sequencing Matcher', ["chemistry", "depth", "sequencer"])

const CustomerSampleMatcher = partialMatcher([['customer', 'sample']], [], 'Customer Sample Name Matcher')

const parseNumber = (entry: string): number => (entry.trim() ? Number(entry) : NaN)

const isLatitude = (value: number): boolean => !isNaN(value) && Math.abs(value) <= 90

const isLongitude = (value: number): boolean => !isNaN(value) && Math.abs(value) <= 180

const emptyOr =
  (validator: (entry: string) => boolean) =>
  (entry: string): boolean =>
    !entry?.trim() || validator(entry)

/* Lenient on purpose: suggest the column whichever order the values are in; the parser decides the order. */
const CoordinatesMergedMatcher = partialMatcher([['coordinates']], [], 'Coordinates merged matcher', undefined, [
  emptyOr((entry) => {
    const parts = entry.split(',').map(parseNumber)
    if (parts.length !== 2) {
      return false
    }
    const [first, second] = parts
    return (isLatitude(first) && isLongitude(second)) || (isLongitude(first) && isLatitude(second))
  })
])

const CoordinatesMatcherLat = wordMatcher(['lat', 'latitude'], 'Coordinates lat matcher', [
  emptyOr((entry) => isLatitude(parseNumber(entry.replace(',', '.'))))
])

const CoordinatesMatcherLon = wordMatcher(['lon', 'long', 'longitude'], 'Coordinates lon matcher', [
  emptyOr((entry) => isLongitude(parseNumber(entry.replace(',', '.'))))
])

export const defaultMatchers: Record<CSVFieldType, HeaderMatcher[]> = {
  forwardPrimer: [ForwardPrimerMatcher],
  reversePrimer: [ReversePrimerMatcher],
  customerSample: [CustomerSampleMatcher],
  sequenceId: [SequenceMatcher],
  coordinatesMerged: [CoordinatesMergedMatcher],
  coordinatesLat: [CoordinatesMatcherLat],
  coordinatesLon: [CoordinatesMatcherLon],
  samplingDate: [partialMatcher([['samplingDate']], [], 'Sampling Date Matcher')],
  samplingStart: [partialMatcher([['samplingStart']], [], 'Sampling Start Date Matcher')],
  samplingEnd: [partialMatcher([['samplingEnd']], [], 'Sampling End Date Matcher')],
  matrixType: [partialMatcher([['matrixType']], [], 'Matrix Type Matcher')],
  extractionKit: [partialMatcher([['extractionKit']], [], 'Extraction Kit Matcher')],
  trapType: [partialMatcher([['trapType']], [], 'Trap Type Matcher')],
  collectionType: [partialMatcher([['collectionType']], [], 'Collection Type Matcher')],
  sequencer: [partialMatcher([['sequencer']], [], 'Sequencer Matcher')],
  sequencingChemistry: [partialMatcher([['sequencingChemistry']], [], 'Sequencing Chemistry Matcher')],
  sequencingDepth: [partialMatcher([['sequencingDepth']], [], 'Sequencing Depth Matcher')],
  localityType: [partialMatcher([['localityType']], [], 'Locality Matcher')],
  habitatType: [partialMatcher([['habitatType']], [], 'Habitat Matcher')],
}
